import React, { useState } from 'react';
import { useAuth } from 'react-oidc-context';

const buttonStyle = {
  backgroundColor: '#007bff',
  color: 'white',
  padding: '10px 20px',
  margin: '20px 0',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: 'bold',
  transition: 'all 0.3s ease',
};

const disabledButtonStyle = {
  ...buttonStyle,
  backgroundColor: '#cccccc',
  cursor: 'not-allowed',
};

function PaymentPage() {
  const auth = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handlePayment = async () => {
    setLoading(true);
    setError(null);

    try {
      // Make sure user is authenticated
      if (!auth.isAuthenticated || !auth.user?.access_token) {
        setError('Please sign in to subscribe');
        setLoading(false);
        return;
      }

      // Call your Lambda function to create checkout session
      const response = await fetch(
        'https://2kv3mokjp5.execute-api.us-east-2.amazonaws.com/prod/create-checkout-session',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.user.access_token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create checkout session');
      }

      const data = await response.json();

      // Redirect to Stripe Checkout
      if (data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      } else {
        throw new Error('No checkout URL returned');
      }
    } catch (err) {
      console.error('Payment error:', err);
      setError(err.message || 'Failed to start checkout process. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Subscribe to TickrTrends</h1>
      <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '30px' }}>
        Get access to Fair Future Value calculations for all 503 S&P 500 stocks
      </p>

      <div style={{
        background: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#007bff' }}>
          $7.99<span style={{ fontSize: '1rem', fontWeight: 'normal' }}>/month</span>
        </div>
        <p style={{ marginTop: '10px', color: '#666' }}>Cancel anytime • No hidden fees</p>
      </div>

      {error && (
        <div style={{
          background: '#fee',
          border: '1px solid #fcc',
          padding: '12px',
          borderRadius: '6px',
          marginBottom: '20px',
          color: '#c33'
        }}>
          {error}
        </div>
      )}

      {!auth.isAuthenticated ? (
        <div style={{ marginTop: '20px' }}>
          <p style={{ color: '#666', marginBottom: '16px' }}>
            Please sign in to subscribe
          </p>
          <button
            style={buttonStyle}
            onClick={() => auth.signinRedirect()}
          >
            Sign In
          </button>
        </div>
      ) : (
        <button
          style={loading ? disabledButtonStyle : buttonStyle}
          onClick={handlePayment}
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Subscribe Now'}
        </button>
      )}

      <p style={{ fontSize: '0.9rem', color: '#999', marginTop: '20px' }}>
        By subscribing, you agree to our Terms of Service and Privacy Policy.
        Secure payment processing by Stripe.
      </p>
    </div>
  );
}

export default PaymentPage;